export default __webpack_public_path__ + "static/media/nav_img_12.536544e6.jpg";